module.exports = __webpack_public_path__ + "static/about-the-singer-headshot-ba98b28634e31905d5cfa9f046ed6a4d.png";